import * as React from 'react';

import { useNaptimeContext } from 'bundles/naptimejs/util/NaptimeContextAdapter';

/**
 * Returns a callback that clears the client-side Naptime cache for a given
 * resource name. After calling it, the next `useNaptime` fetch for that
 * resource will hit the server instead of serving stale data.
 *
 * This clears both the `responseCache` (finder/getAll URL → ids/paging) and
 * the `elementsToUrlMapping` (element key → source URLs), mirroring the
 * internal invalidation the NaptimeStore does after mutations.
 */
const useInvalidateNaptimeCache = () => {
  const context = useNaptimeContext();

  return React.useCallback(
    (resourceName: string) => {
      const naptimeStore = context.getStore('NaptimeStore');

      Object.keys(naptimeStore.responseCache).forEach((key) => {
        if (key.indexOf(resourceName) !== -1) {
          delete naptimeStore.responseCache[key];
        }
      });

      Object.keys(naptimeStore.elementsToUrlMapping).forEach((key) => {
        if (key.indexOf(resourceName) !== -1) {
          delete naptimeStore.elementsToUrlMapping[key];
        }
      });
    },
    [context]
  );
};

export default useInvalidateNaptimeCache;
